import { render, staticRenderFns } from "./VideoResource.vue?vue&type=template&id=39b2d64d&scoped=true&"
import script from "./VideoResource.vue?vue&type=script&lang=js&"
export * from "./VideoResource.vue?vue&type=script&lang=js&"
import style0 from "./VideoResource.vue?vue&type=style&index=0&id=39b2d64d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b2d64d",
  null
  
)

export default component.exports